import { FloatingLabel, Form } from 'react-bootstrap';

interface EditStringProps {
  /** Floating label + placeholder. Omit to render a bare control (the caller supplies its own label, e.g. via `Field`). */
  readonly label?: string;
  readonly value: string | null;
  readonly onChange: (value: string | null) => void;
  readonly mandatory?: boolean;
}

/**
 * Standardised text-input wrapper used by edit dialogs throughout the
 * app. Renders a Bootstrap `Form.Control type="text"`. When `label` is
 * given it is wrapped in a `FloatingLabel` (and reused as the
 * placeholder); when omitted, the bare control renders and the caller
 * owns the label (e.g. a `Field` above it). `mandatory` appends " *" to
 * the floating label and sets the input's `required` attribute. The
 * empty input string is normalised to `null` for the caller (and back
 * to '' for display) so the surrounding form state can treat "not
 * filled" honestly.
 */
export const EditString = ({ label, value, onChange, mandatory = false }: EditStringProps) => {
  const control = (
    <Form.Control
      type="text"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
      placeholder={label}
      required={mandatory}
    />
  );
  return label ? <FloatingLabel label={mandatory ? `${label} *` : label}>{control}</FloatingLabel> : control;
};
